/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropInWatchSummary
 */
export interface DropInWatchSummary {
    /**
     * 
     * @type {number}
     * @memberof DropInWatchSummary
     */
    totalSessions: number;
    /**
     * 
     * @type {number}
     * @memberof DropInWatchSummary
     */
    totalHours: number;
    /**
     * 
     * @type {number}
     * @memberof DropInWatchSummary
     */
    avgSessionMinutes: number;
    /**
     * 
     * @type {number}
     * @memberof DropInWatchSummary
     */
    uniqueViewers: number;
}

/**
 * Check if a given object implements the DropInWatchSummary interface.
 */
export function instanceOfDropInWatchSummary(value: object): value is DropInWatchSummary {
    if (!('totalSessions' in value) || value['totalSessions'] === undefined) return false;
    if (!('totalHours' in value) || value['totalHours'] === undefined) return false;
    if (!('avgSessionMinutes' in value) || value['avgSessionMinutes'] === undefined) return false;
    if (!('uniqueViewers' in value) || value['uniqueViewers'] === undefined) return false;
    return true;
}

export function DropInWatchSummaryFromJSON(json: any): DropInWatchSummary {
    return DropInWatchSummaryFromJSONTyped(json, false);
}

export function DropInWatchSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropInWatchSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'totalSessions': json['totalSessions'],
        'totalHours': json['totalHours'],
        'avgSessionMinutes': json['avgSessionMinutes'],
        'uniqueViewers': json['uniqueViewers'],
    };
}

export function DropInWatchSummaryToJSON(json: any): DropInWatchSummary {
    return DropInWatchSummaryToJSONTyped(json, false);
}

export function DropInWatchSummaryToJSONTyped(value?: DropInWatchSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalSessions': value['totalSessions'],
        'totalHours': value['totalHours'],
        'avgSessionMinutes': value['avgSessionMinutes'],
        'uniqueViewers': value['uniqueViewers'],
    };
}

